<div mat-dialog-title>{{'subscriptions.delete.modal.title' | translate}}</div>
@if (!loading) {
  <div>
    @if (!deleteError && !deleteSuccess) {
      <mat-dialog-content>
        {{'subscriptions.delete.modal.content' | translate : {name: subscription.name.toUpperCase()} }}
      </mat-dialog-content>
      <mat-dialog-actions>
        <button class="btn btn--outline-grey-color mr-20" mat-dialog-close>{{'action.cancel' | translate}}</button>
        <button class="btn btn--danger" (click)="deleteSubscription()">{{'action.delete_subscription' | translate}}</button>
      </mat-dialog-actions>
    } @else {
      @if (deleteSuccess) {
        <div>
          <div class="alert alert-success">
            {{deleteSuccess}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--primary" [mat-dialog-close]="true"
            routerLink="/customer-accounts">{{'subscriptions.delete.modal.return_list' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
      @if (deleteError) {
        <div>
          <div class="alert alert-error">
            {{deleteError}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--outline-grey-color" mat-dialog-close>{{'action.cancel' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
    }
  </div>
}
<span class="ui-loading" [model]="{isLoading: loading}"></span>
